module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAD4SURBVHgB7djNDYJAEMXxt1oFoQsqsARLsBOxEi1F74TYghfoAt3ZBE9yYuZx8P0SErgs84cDH4CIiIiIrNY0zck2kO3hwAZPKV3zdqyqCuM4PkCyg7Mc0eagM0hc7kC+4s+6rlPePdhxjjiw7oRLgBmG4b5FhFuA2SLCNcCwI9wDDDMiJMCwIsICDCMiNMBER4QHmIWIlz0/sJL7k3jJNE1vBKAE2KuFvWLMx3n/0vf9DQ4Sgv0avuu6Fk5CA6KHL2siCGP4si4CsIYva8MZc/iyPhyxhy/ngJMthi/ngYP5m/i7KGl4E/FNTBve1Va/VURERET+2QdaTYkdMKUo6wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/navbar_right arrow.png
// module id = Xahc
// module chunks = 0